import { TranslateService } from '@ngx-translate/core';
import { Component, OnInit, ViewChild, ViewChildren, QueryList, ChangeDetectorRef, NgZone, HostListener, ElementRef } from '@angular/core';
import { Header } from 'src/app/models/header.model';
import { ModalController, IonContent } from '@ionic/angular';
import { FailuresDetailListComponent } from '../failures-detail-list/failures-detail-list.component';
import { Enclosure } from 'src/app/models/enclosure.model';
import { ItemSpot } from 'src/app/models/item-spot.model';
import { FlawDetail } from 'src/app/models/flaw-detail.model';
import { RequestCreationService } from 'src/app/core/services/request-creation/request-creation.service';
import { UtilsService } from 'src/app/core/services/utils/utils.service';
import { FailureSelection } from 'src/app/models/Failure-creation.model';
import { fromEvent, Subscription } from 'rxjs';

@Component({
  selector: 'app-add-failure-modal',
  templateUrl: './add-failure-modal.component.html',
  styleUrls: ['./add-failure-modal.component.scss'],
})
export class AddFailureModalComponent implements OnInit {

  private backbuttonSubscription: Subscription;
  public header: Header = {
    title: 'Agregar fallas',
    icon: 'close',
    // secondIcon: 'add',
    principalPage: false
  }

  public activeStep: number = 0;

  public selectedFailures: FailureSelection[] = [];

  public recintoIndex: any;

  public failure: string = '';

  @ViewChild('failureDetails', { static: false }) failureDetailsListComp: FailuresDetailListComponent;
  @ViewChildren('failures') listedFailures: QueryList<any>;
  @ViewChild('swiper', { static: false }) slides: ElementRef;
  @ViewChild(IonContent, { static: false }) content: IonContent;


  public enclosures: Enclosure[] = [];
  public selectedEnclosureId: number = null;
  public selectedItemId: number = null;
  public selectedItemSpot: ItemSpot = null;
  public itemsSpots: ItemSpot[] = [];
  public failureDetails: FlawDetail[] = [];
  public createButtonDisabled: boolean = false;
  public filesAvailabilitySubs;
  public slideUpdateSubs;

  private itemSpotName: string = '';
  private enclosureName: string = '';
  public company: string = '';

  @HostListener('window:resize')
  onResize() {
    setTimeout(() => this.slides?.nativeElement.swiper.update(), 100);
  }

  constructor(
    private requestCreationService: RequestCreationService,
    private utils: UtilsService,
    public modalCtrl: ModalController,
    public zone: NgZone,
    private translate : TranslateService
  ) {
    this.filesAvailabilitySubs = this.requestCreationService.getFilesAvailability()
      .subscribe(() => this.checkImagesAvailability());

    this.slideUpdateSubs = this.utils.updateSlide.subscribe(() => this.slides?.nativeElement.swiper.updateAutoHeight());
  }

  async ngOnInit() {
    this.header.title = this.translate.instant('add-failure-modal.Agregar fallas')
    const { company } = await this.utils.getFromStorage('unitParams');
    this.company = company;

    const event = fromEvent(document, 'backbutton');
    this.backbuttonSubscription = event.subscribe(async () => {
      const modal = await this.modalCtrl.getTop();
      if (modal)
        modal.dismiss();
    });
  }

  ngAfterViewInit() {

  }

  async selectEnclosure(enclosure: Enclosure) {
    this.content.scrollToTop();
    this.enclosureName = enclosure.recinto_nombre;
    this.selectedEnclosureId = enclosure.id;
    this.itemSpotName = '';
    this.selectedItemId = null;
    this.slides?.nativeElement.swiper.slideNext();
    this.slideChange();
  }

  async selectItemSpot(itemSpot: ItemSpot) {
    this.content.scrollToTop();
    this.itemSpotName = ` / ${itemSpot.lugar.lugar_nombre} / ${itemSpot.item.item_nombre}`;
    this.selectedItemId = itemSpot.item.item_id;
    this.selectedItemSpot = itemSpot;
    await this.slides.nativeElement.swiper.slideNext();
    this.slideChange();
  }


  async reset() {
    if (this.activeStep > 0) {
      const canLeave = await this.utils.confirmLeave();
      if (canLeave) {
        this.activeStep = 0;
        this.failure = '';
        await this.slides?.nativeElement.swiper.slideTo(0);
      }
    }

  }

  addFailures() {
    this.failureDetailsListComp.add();
  }

  async add(failureDetails) {
    for (const iterator of failureDetails) {
      this.selectedFailures.push({
        configId: this.selectedItemSpot.id,
        detailId: iterator.id,
        name: `${this.failure} / ${iterator.name}`,
        enclosure: this.enclosureName,
        itemSpot: this.itemSpotName,
        failDetail: iterator.name,
        observation: this.translate.instant('add-failure-modal.Sin observación'),
        attachments: []
      });
    }
    this.modalCtrl.dismiss(this.selectedFailures);
  }


  deleteFlaw(id) {
    this.selectedFailures.splice(this.selectedFailures.findIndex(el => `${el.configId}${el.detailId}` === id), 1);
  }


  checkImagesAvailability() {
    this.zone.run(() => {
      let shouldDisabled = false;
      this.listedFailures['_results'].map(({ flaw }) => {
        flaw.attachments.map(el => {
          if (!el.availability)
            shouldDisabled = true;
        })
      })
      this.createButtonDisabled = shouldDisabled;
    })
  }

  async close() {
    if (this.selectedEnclosureId) {
      const canLeave = await this.utils.confirmLeave();
      if (canLeave) {
        this.modalCtrl.dismiss('close');
        this.filesAvailabilitySubs.unsubscribe();
        this.slideUpdateSubs.unsubscribe();
      }
    } else {
      this.modalCtrl.dismiss('close');
      this.filesAvailabilitySubs.unsubscribe();
      this.slideUpdateSubs.unsubscribe();
    }

  }

  async slideChange() {
    const [prev, act] = await Promise.all([this.slides.nativeElement.swiper.previousIndex, this.slides.nativeElement.swiper.activeIndex]);
    if (prev > act) {
      this.content.scrollToTop();
    }
    this.activeStep = await this.slides?.nativeElement.swiper.activeIndex;
    // this.activeStep = this.activeStep < 0 ? 0 : this.activeStep;
    this.failure = act === 0 ? this.enclosureName : this.enclosureName + this.itemSpotName;

    setTimeout(() => {
      this.slides?.nativeElement.swiper.update();
      this.slides?.nativeElement.swiper.updateAutoHeight(0);
    });
  }


  stepperClicked(clicked: number) {
    this.slides?.nativeElement.swiper.slideTo(clicked);
    this.slideChange();
  }

  ngOnDestroy() {
    this.backbuttonSubscription.unsubscribe();
  }

}
